module.exports = __webpack_public_path__ + "static/img/img2.491a617.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/slideVerify/assets/img2.jpg
// module id = E0fO
// module chunks = 1